export const GO_TO_NEXT_DATE = 'features/CurrentDate/GO_TO_NEXT_DATE';
export const GO_TO_PREV_DATE = 'features/CurrentDate/GO_TO_PREV_DATE';
